<template>
  <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" />
</template>

<script>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  export default {
    components: {},
    setup() {
      const store = useStore();

      function refreshPage(payload) {
        store.dispatch('getZoneGroups', payload);
      }

      const zoneGroups = computed(() => store.getters.zoneGroups);

      const structure = {
        title: 'views.releaseZonesGroups.zoneGroupsList',

        creationLink: {
          title: 'buttons.createGroup',
          namePath: 'menu.sharing.createZone',
        },
        data: [
          {
            title: 'user.name.first',

            fields: [
              {
                placeholder: '@',
                name: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'name',
              },
            ],
            span: 1,
            link: { idField: 'id', path: '/sharing/zones/:id' },
          },
          {
            title: 'description',

            field: 'description',
            span: 3,
          },
          {
            title: 'views.timeEntries.creationDate',

            field: 'created_at',
            format: 'datetime',
            span: 2,
          },
        ],
      };
      return {
        data: zoneGroups,
        structure,
        refreshPage,
      };
    },
  };
</script>

<style></style>
